var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticStyle:{"height":"53vh"}},[_c('v-alert',{attrs:{"outlined":"","type":"success","text":""}},[_vm._v(" Please Check your email. Password reset credential has been sent to your email. ")])],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }